import React, { Component } from "react";
import GoogleMapReact from "google-map-react";
import PinColors from "./sidemenu/pincolors";
import { Button, Overlay } from "react-bootstrap";
import { Link } from "react-router-dom";
import { isPlanActive } from "../common/duck/planActive";

const SatelliteView = {
  options(maps) {
    return {
      mapTypeId: maps.MapTypeId.HYBRID,
    };
  },
};
const MapView = {
  options(maps) {
    return {
      mapTypeId: maps.MapTypeId.ROADMAP,
    };
  },
};
const markerStyle = {
  textAlign: "center",
  transform: "translate(-40%, -68%)",
  position: "absolute",
};

function LinkedPin({ farmid, site, lat, lng, view, userRole }) {
  let planActive = isPlanActive(userRole, site.planDetails);
  return (
    <Link
      to={ planActive ? {
        pathname: `/farm/${farmid}/site/${site.siteId}/${site.id}/${site.twigId}/graph`,
        state: site,
      } : "#" }
    >
      {view === "ACTIVE" ? <div className="multi-farm-pin d-flex">
        <PinColors
          key={site.siteId}
          width="70"
          height="70"
          style={markerStyle}
          state={site.twigDetails?.state}
          label={site.siteId}
          lat={lat}
          lng={lng}
        />
        <div>
          <h3 className="text-black">{site.siteId}</h3>
        </div>
      </div> :
        <div className="rectmarker">
          <p>{site.siteId}</p>
        </div>}
    </Link>
  );
}

class MultiFarmMap extends Component {
  state = {
    data: [],
    errors: null,
    center: null,
    show: false,
    back: false,
    maptype: "SatelliteView",
    flag: true,
    view: '?query=Active'

  };

  map = null;
  componentDidMount() {
    if (this.props.selectedView) {

      this.setState({
        selectedView: this.props.selectedView,

      });
    }
  }


  componentDidUpdate(prevProps) {
    if (this.props.selectedView !== prevProps.selectedView) {
      this.setState({ selectedView: this.props.selectedView })
    }
    if (this.props.sites !== prevProps.sites) {
      this.setSiteData(this.props.sites);
    }
  }

  loadApiMethods = (map, maps) => {
    this.mapPanTo = map.panTo.bind(map);
    this.map = map;
    this.maps = maps;



    this.setSiteData();
    // console.log('loadApiMethods', this.props.farmid)

    // siteService
    //   .getSitesForFarms(this.props.farmid)
    //   .then((response) => {
    //     this.setSiteData(response);
    //   })

    //   .catch(
    //     (error) =>
    //       console.log(error) ||
    //       this.setState({ errors: { serviceError: error } })
    //   );
  };

  setSiteData() {
    this.setState({ data: [] })
    const data = this.props.sites.map((sites) => Object.keys(sites)[0] &&
      Object.values(sites)[0].map((site) => site));
    let selecteddata = [];


    data.map((site) => {


      const sites = site.map(
        ({ siteId, name, location, twigId, id, twigDetails, farm, status, planDetails }) => ({
          siteId,
          name,
          location,
          twigId,
          id,
          twigDetails,
          farm,
          status,
          planDetails,
        })
      );
      selecteddata = [...selecteddata, ...sites]
      if(sites.length > 0) this.setMapBounds(this.map, this.maps, sites); // Update map bounds only if a particular farm has sites.


      //} 
      return 1;
    });
    this.setState({ data: selecteddata });

  }

  setMapBounds = (map, maps, data) => {
    if (!map || !maps) return; // Create LatLngBounds object only after the maps object gets initialized. 
    let bounds = new maps.LatLngBounds();

    data.length !== 0 && data.map((site) => {
      return bounds.extend(
        new maps.LatLng(site?.location?.latitude, site?.location?.longitude)
      );
    });
    map.fitBounds(bounds);
  };

  backdropClass = "backdrop";

  openBackdrop = () => {
    this.setState({ show: !this.state.show, back: true });
    this.backdropClass += " open";
  };
  closeBackdrop = () => {
    this.setState({ show: false, back: false });
    this.backdropClass = "backdrop";
  };

  handleMapView = (maptype) => {
    this.setState({ maptype, show: false, back: false });
  };

  mapShowClass = "googleMapReact";
  handleMapToggle = () => {
    if (this.props.navOpen) this.mapShowClass = "googleMapReact";
    else this.mapShowClass = " ";
  };

  googleMapReact = (key, maptype, view) => {


    return (
      <GoogleMapReact
        style={{ position: "static" }}
        bootstrapURLKeys={{ key }}
        defaultCenter={this.props.center}
        defaultZoom={this.props.zoom}
        options={
          maptype === "SatelliteView" ? SatelliteView.options : MapView.options
        }
        yesIWantToUseGoogleMapApiInternals={true}
        onGoogleApiLoaded={({ map, maps }) => {
          this.loadApiMethods(map, maps);
        }}
      >
        {this.state.data !== [] &&
          this.state.data.map((site) => (site.status === view &&
            <LinkedPin
              key={site.siteId}
              lat={site.location?.latitude}
              lng={site.location?.longitude}
              site={site}
              farmid={site.farm?.objectId}
              view={view}
              userRole={this.props.userRole}
            />
          ))}
      </GoogleMapReact>
    );
  };

  render() {

    const view = this.props.selectedView === "?query=Active" ? 'ACTIVE' : 'PENDING'
    const { show, maptype } = this.state;
    const key = process.env.REACT_APP_GOOGLE_MAP_API_KEY;

    this.handleMapToggle();
    this.googleMapReact();
    return (
      // Important! Always set the container height explicitly
      <div style={{ width: "100%" }}>
        <div className={this.backdropClass} onClick={this.closeBackdrop}></div>
        <Button
          variant="none"
          className="mapOptionsToggleButton"
          onClick={this.openBackdrop}
        >
          Map Options
        </Button>
        <Overlay show={show} placement="bottom">
          {({ placement, show: _show }) => (
            <div className="toggleMapOptions d-flex flex-column align-items-center">
              <div className="optionsFont">
                <span onClick={() => this.handleMapView("SatelliteView")}>
                  Satellite View
                </span>
              </div>
              <div className="optionsFont">
                <span onClick={() => this.handleMapView("MapView")}>
                  Map View
                </span>
              </div>
            </div>
          )}
        </Overlay>
        <div className={this.mapShowClass}>
          {this.props.check && this.googleMapReact(key, maptype, view)}
          {!this.props.check && this.googleMapReact(key, maptype, view)}
        </div>
      </div>
    );
  }
}

export default MultiFarmMap;
